export const setOpenAppActiveActionType = 'UI_STATE/SET_OPEN_SUGGEST_APP_ACTIVE'
export const setBreadcrumbActionType = 'UI_STATE/SET_BREADCRUMB'
export const setIsMeaningfulTimeActionType = 'UI_STATE/SET_IS_MEANINGFUL_TIME'

export const setSuggestToOpenAppActive =
  (isActive: boolean) => (dispatch: any) => {
    dispatch({
      type: setOpenAppActiveActionType,
      payload: {
        isActive,
      },
    })
  }

export const setBreadcrumb = (breadcrumb: Array<object>) => (dispatch: any) => {
  dispatch({
    type: setBreadcrumbActionType,
    payload: {
      breadcrumb,
    },
  })
}

export const setIsMeaningfulTime =
  (isMeaningfulTime: { state: boolean; force?: boolean }) =>
  (dispatch: any) => {
    dispatch({
      type: setIsMeaningfulTimeActionType,
      payload: {
        isMeaningfulTime,
      },
    })
  }
